<template>
  <div :style="{ width: clientPlatform == 'Web' ? '450px' : '100%' }">
    <div class="flex-row justify-content-between width100">
      <!-- LEFT CONTENT -->
      <div class="flex-column align-items-start tl">
        <!-- Order Info Text -->
        <div class="active-order-card-info fs-12">
          <div
            class="hide-shimmer-text shimmer-container rounded"
            style="width: 160px; height: 14px"
          >
            Order #123 • 2 Items • ₹299
          </div>
        </div>

        <!-- ETA (Arriving in XX min) -->
        <div class="active-order-card-time mb12">
          <div
            class="hide-shimmer-text shimmer-container rounded mb4"
            style="width: 70px; height: 12px"
          >
            Delay
          </div>

          <div
            class="hide-shimmer-text shimmer-container rounded"
            style="width: 100px; height: 14px"
          >
            Arriving in 12 min
          </div>
        </div>

        <!-- Status Message -->
        <div class="active-order-card-desc fs-16 fw-700">
          <div
            class="hide-shimmer-text shimmer-container rounded"
            style="width: 180px; height: 16px"
          >
            Being prepared
          </div>
        </div>
      </div>

      <!-- RIGHT CONTENT -->
      <div class="flex-column align-items-flex-end">
        <!-- Expand Icon -->

        <!-- Image -->
        <div class="active-order-card-image mt8">
          <div
            class="hide-shimmer-text shimmer-container rounded"
            style="width: 60px; height: 60px"
          >
            img
          </div>
        </div>
      </div>
    </div>

    <!-- PROGRESS BAR SHIMMER -->
    <div class="mt12">
      <div
        class="hide-shimmer-text shimmer-container rounded"
        style="width: 100%; height: 8px"
      >
        progress
      </div>
    </div>

    <!-- BOTTOM ROW -->
    <div class="inline-flex justify-content-between w100 pt12">
      <div
        class="hide-shimmer-text shimmer-container rounded"
        style="width: 120px; height: 14px"
      >
        help text
      </div>
    </div>
  </div>
</template>

<script>
import { clientPlatform } from "../config/apiEndpoints";
export default {
  name: "ActiveOrderCardShimmer",
  data() {
    return { clientPlatform };
  },
};
</script>
